import S from 'common/service/sanctuary';
import { type } from 'ramda';
import { createSelector } from 'reselect';

import {
  isLoading,
  factory as loadingFactory,
} from '../loading/selectors';

import {
  getErrorContext,
  factory as errorFactory,
} from '../error/selectors';

export {
  isLoading,
  getErrorContext,
};

const isUndefined = data => S.equals('Undefined', type(data));

const getData = S.get(S.complement(isUndefined), 'data');

const getDataUnsafe = S.prop('data');

// getResourceContext :: Scope -> Maybe (Either resource)
export const getResourceContext = createSelector(
  getData,
  getErrorContext,
  (maybeData, errorContext) => (
    errorContext.isRight && maybeData.isNothing
      ? S.Nothing
      : S.Just(S.map(getDataUnsafe, errorContext))
  ),
);

// getResourceMaybe :: Scope -> Maybe resource
export const getResourceMaybe = createSelector(
  getResourceContext,
  S.chain(S.eitherToMaybe),
);

export const factory = getScope => ({
  ...loadingFactory(getScope),
  ...errorFactory(getScope),
  getResourceContext: createSelector(
    getScope,
    getResourceContext,
  ),
  getResourceMaybe: createSelector(
    getScope,
    getResourceMaybe,
  ),
});

export default factory;
